import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { ModalPc } from '@/shared/ui/ModalPc'
import { ProgressBar } from '@/shared/ui/ProgressBar'
import { MODAL_ROW_CLASS } from '@/shared/ui/buttonRow'
import type { ProblemNewDraft } from '@/public/features/problem/types'
import { TOTAL_STEPS } from '@/public/features/problem/constants/problemNew'
import { Buttons, SubmitError } from '@/public/features/problem/ui/problemNew/parts'
import {
  Analyzing,
  Done,
  DoneButtons,
  RevisionButtons,
  RevisionNeeded,
} from '@/public/features/problem/ui/problemNew/Result'
import { Step } from '@/public/features/problem/ui/ProblemNewMobile'

export function ProblemNewModalPc({
  draft,
  closeTo,
}: {
  draft: ProblemNewDraft
  closeTo: string
}) {
  const navigate = useNavigate()

  const close = useCallback(() => navigate(closeTo, { replace: true }), [navigate, closeTo])

  return (
    <ModalPc
      title="시민 문제 등록"
      onClose={close}
      footer={
        draft.stage === 'form' ? (
          <Buttons draft={draft} rowClass={MODAL_ROW_CLASS} />
        ) : draft.stage === 'revision' ? (
          <RevisionButtons onRevise={draft.goRevise} rowClass={MODAL_ROW_CLASS} />
        ) : (
          <DoneButtons rowClass={MODAL_ROW_CLASS} />
        )
      }
    >
      {draft.stage === 'form' ? <ProgressBar step={draft.step} total={TOTAL_STEPS} /> : null}

      <div
        data-scroll-root
        className={
          draft.step === TOTAL_STEPS
            ? 'flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto pt-3'
            : 'flex min-h-0 flex-1 flex-col gap-[45px] overflow-y-auto pt-3'
        }
      >
        {draft.stage === 'analyzing' ? (
          <Analyzing />
        ) : draft.stage === 'revision' ? (
          <RevisionNeeded reasons={draft.revisionReasons} />
        ) : draft.stage === 'done' ? (
          <Done editLinkPath={draft.editLinkPath} isEdit={draft.isEdit} />
        ) : (
          <Step draft={draft} />
        )}

        {draft.stage === 'form' ? <SubmitError error={draft.error} /> : null}
      </div>
    </ModalPc>
  )
}
